(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crisaldo-puf"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('crisaldo-puf')) {
    customElements.define('crisaldo-puf', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.options = [...this.querySelectorAll('[data-option-position]')];
        this.form = this.querySelector('form');
        this.file = this.querySelector('[data-design-file]');
        this.preview = this.querySelector('[data-design-preview]');
        this.options.forEach(option => option.addEventListener('change', () => this.update()));
        this.file.addEventListener('change', () => this.previewFile());
        this.form.addEventListener('submit', event => {
          if (!this.variant?.available || !this.validateFile() || !this.form.checkValidity()) {
            event.preventDefault();
            this.form.reportValidity();
          }
        });
        this.stickyButton = this.querySelector('[data-sticky-button]');
        this.stickyButton.addEventListener('click', () => {
          if (!this.variant?.available) return;
          if (!this.validateFile() || !this.form.checkValidity()) {
            this.form.reportValidity();
            return;
          }
          this.form.requestSubmit(this.querySelector('[data-buy-now]'));
        });
        this.buyObserver = new IntersectionObserver(entries => {
          this.querySelector('[data-sticky-buy]').hidden = entries[0].isIntersecting;
        }, { threshold: 0.1 });
        this.buyObserver.observe(this.querySelector('[data-buy-now]'));
        this.update();
      }
      update() {
        const values = this.options.map(option => option.value);
        this.variant = this.variants.find(variant => variant.options.every((value, index) => value === values[index]));
        const personalized = values[1] === this.dataset.personalizedValue;
        const panel = this.querySelector('[data-customization]');
        panel.hidden = !personalized;
        panel.disabled = !personalized;
        this.file.required = personalized;
        this.querySelector('[data-gift]').hidden = !personalized;
        this.querySelector('[data-final-normal]').hidden = personalized;
        this.querySelector('[data-final-custom]').hidden = !personalized;
        const giftStory = this.querySelector('[data-gift-story]');
        if (giftStory) giftStory.hidden = !personalized;
        const heading = this.querySelector('[data-product-heading]');
        heading.textContent = personalized ? heading.dataset.personalizedTitle : heading.dataset.normalTitle;
        const hero = this.querySelector('[data-hero-heading]');
        hero.textContent = personalized ? hero.dataset.personalized : hero.dataset.normal;
        const intro = this.querySelector('[data-product-intro]');
        intro.textContent = personalized ? intro.dataset.personalized : intro.dataset.normal;
        const delivery = this.querySelector('[data-delivery]');
        delivery.textContent = personalized ? delivery.dataset.personalized : delivery.dataset.normal;
        this.querySelector('[data-status]').textContent = this.variant?.available ? '' : this.dataset.unavailable;
        this.querySelectorAll('button[type=submit]').forEach(button => { button.disabled = !this.variant?.available; });
        if (!this.variant) return;
        this.querySelector('[data-variant-id]').value = this.variant.id;
        this.querySelector('[data-price]').textContent = this.variant.price;
        this.querySelector('[data-final-price]').textContent = this.variant.price;
        this.querySelector('[data-sticky-price]').textContent = this.variant.price;
        this.querySelector('[data-sticky-color]').textContent = values[0];
        this.stickyButton.disabled = !this.variant.available;
        const image = this.querySelector('.crisaldo-puf__image');
        if (image && this.variant.image) {
          image.removeAttribute('srcset');
          image.src = this.variant.image;
          image.alt = this.variant.alt;
        }
        const compareImage = this.querySelector('[data-compare-image]');
        if (compareImage && this.variant.image) {
          compareImage.removeAttribute('srcset');
          compareImage.src = this.variant.image;
          compareImage.alt = this.variant.alt;
        }
        const sizeImage = this.querySelector('[data-size-image]');
        if (sizeImage && this.variant.image) {
          sizeImage.removeAttribute('srcset');
          sizeImage.src = this.variant.image;
          sizeImage.alt = this.variant.alt;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', this.variant.id);
        window.history.replaceState({}, '', url);
        this.validateFile();
      }
      validateFile() {
        if (!this.file.required) {
          this.file.setCustomValidity('');
          this.querySelector('[data-file-error]').hidden = true;
          return true;
        }
        const file = this.file.files[0];
        const allowed = new Set(['image/jpeg', 'image/png', 'image/webp']);
        const valid = !file || (allowed.has(file.type) && file.size <= 10 * 1024 * 1024);
        const error = this.querySelector('[data-file-error]');
        this.file.setCustomValidity(valid ? '' : error.textContent.trim());
        error.hidden = valid;
        return valid;
      }
      previewFile() {
        if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
        this.preview.hidden = true;
        this.preview.removeAttribute('src');
        const file = this.file.files[0];
        if (file && this.validateFile()) {
          this.previewUrl = URL.createObjectURL(file);
          this.preview.src = this.previewUrl;
          this.preview.hidden = false;
        }
      }
      disconnectedCallback() {
        this.buyObserver?.disconnect();
        if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
